import { render, staticRenderFns } from "./starter.vue?vue&type=template&id=1d69af38&scoped=true&"
import script from "./starter.vue?vue&type=script&lang=js&"
export * from "./starter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d69af38",
  null
  
)

export default component.exports